import { useTranslation } from 'react-i18next'

const JAPANESE_LOCALE = 'ja_JP'

export type I18nUrls = {
  termsUrl: string
  faqUrl: string
  faqArCameraUrl: string
  privacyPolicyUrl: string
}

const JAPANESE_SITE_URLS = {
  termsUrl: 'https://raund.net/terms/?no_layout=true',
  faqUrl: 'https://raund.net/user_qa/?no_layout=true',
  faqArCameraUrl: 'https://raund.net/user_qa/ar_camera/',
  privacyPolicyUrl: 'https://raund.net/privacy/?no_layout=true',
} as const satisfies I18nUrls

const ENGLISH_SITE_URLS = {
  termsUrl: 'https://raund.net/en/terms-en/',
  faqUrl: 'https://raund.net/en/user_qa/',
  faqArCameraUrl: 'https://raund.net/en/user_qa/ar-camera/',
  privacyPolicyUrl: 'https://raund.net/en/privacy-en/',
} as const satisfies I18nUrls

/**
 * ロケールに応じた raund.net の規約・FAQ・プライバシーポリシー URL を返す。
 *
 * 日本語サイトは ja_JP のときだけ。それ以外の言語はすべて英語サイト（/en/）へ振り分ける。
 * raund.net に各言語のページは無く、日本語よりは英語のほうが確実に読めるため
 * （一覧に無い言語を英語に寄せる考え方は Auth / Docs 画面向けの `toPublicPageLocale()` と同じ。
 *  ただし公開画面は 10 言語のカタログを持つため、de_DE 等は英語に寄らない）。
 * ロケールが未確定（SSR / 初期化前）のときは日本語サイトに倒す。
 */
export const resolveI18nUrls = (locale: string | undefined): I18nUrls => {
  if (!locale || locale === JAPANESE_LOCALE) return JAPANESE_SITE_URLS

  return ENGLISH_SITE_URLS
}

export const useI18nUrls = (): I18nUrls => {
  const { i18n } = useTranslation()

  // 返すのはモジュール定数のどちらかなので参照は安定しており、メモ化は不要
  return resolveI18nUrls(i18n.resolvedLanguage)
}
